//TODO:Migration:Phase1:remove
export default value =>
  value == null || typeof value.toString !== 'function'
    ? ''
    : Array.isArray(value)
      ? value.join(', ')
      : value.toString()
